import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetAppMobileProfilesListOut, AppMobileProfile } from './appMobileProfiles.types';
import { mapAppMobileProfiles } from './appMobileProfiles.mapper';


export class AppMobileProfileCatalogService {
  async getProfiles(signal?: AbortSignal): Promise<ApiResponse<AppMobileProfile[]>> {
    const response = await apiClient.get<LC_GetAppMobileProfilesListOut>(
      API_CONFIG.ENDPOINTS.CATALOG.APP_MOBILE_PROFILE_TYPES,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapAppMobileProfiles(response.data) };
  }
}

export const appMobileProfileCatalogService = new AppMobileProfileCatalogService();
